var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-wrap"},[(_vm.title)?_c('h3',{staticClass:"section-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),[_vm._t("title")],_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }